import {I18nKeys} from '@multipass-i18n';
import {GlyphChip, Menu, MenuItem} from '@multipass-ui-components';
import {syncModelWithSelectorOptions, usePublishEvent, useSyncModelWithSelector} from 'esp-js-react';
import {Languages} from 'lucide-react';
import * as React from 'react';

import {LOCALE_META, LocaleChangedEvent, SESSION_STORE_ID, SessionEvents, SessionStoreModel, SupportedLocale, useT} from '../../logic';

const OPTIONS = (Object.entries(LOCALE_META) as [SupportedLocale, typeof LOCALE_META[SupportedLocale]][])
    .map(([locale, meta]) => ({locale, ...meta}));

export const LanguageMenu: React.FunctionComponent = () => {
    const t = useT();
    const publishEvent = usePublishEvent();
    const locale = useSyncModelWithSelector<SessionStoreModel, SupportedLocale>(
        m => m.locale,
        syncModelWithSelectorOptions<SupportedLocale>().setStoreId(SESSION_STORE_ID)
    );
    const select = (next: SupportedLocale) => {
        if (next === locale) {
            return;
        }
        publishEvent(SESSION_STORE_ID, SessionEvents.localeChanged, {locale: next} satisfies LocaleChangedEvent);
    };
    return (
        <Menu iconOnly heading={t(I18nKeys.account.languageLabel)} ariaLabel={t(I18nKeys.account.languageLabel)} triggerIcon={<Languages size={20}/>}>
            {OPTIONS.map(option => (
                <MenuItem
                    key={option.locale}
                    checked={locale === option.locale}
                    onSelect={() => select(option.locale)}
                    icon={<GlyphChip size="sm">{option.glyph}</GlyphChip>}
                    label={t(option.nameKey)}
                    subLabel={option.subKey ? t(option.subKey) : undefined}
                />
            ))}
        </Menu>
    );
};
